// src/i18n/es/users.js
const users = {
    name: 'Usuario |||| Usuarios',
    title: 'Gestión de Usuarios',
    titles: {
        list: 'Usuarios',
        create: 'Crear Usuario',
        edit: 'Editar Usuario',
        show: 'Detalles del Usuario',
        change_password: 'Cambiar Contraseña',
        reset_password: 'Restablecer Contraseña',
        user_information: 'Información del Usuario',
        role_assignment: 'Rol',
        terminal_access: 'Acceso a Terminal',
        new_user: 'Nuevo Usuario',
        edit_user_prefix: 'Editar Usuario:',
        current_assignment: 'Asignación Actual',
        hmi_access: 'Acceso a HMI',
    },
    fields: {
        id: 'ID',
        name: 'Nombre Completo',
        full_name: 'Nombre Completo',
        email: 'Email',
        role: 'Rol',
        hotel: 'Hotel',
        hotelId: 'Hotel Asignado',
        hotelName: 'Hotel',
        group: 'Grupo',
        groupId: 'Grupo Asignado',
        groupName: 'Grupo',
        isActive: 'Activo',
        lastLogin: 'Último acceso',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
        password: 'Contraseña',
        confirmPassword: 'Confirmar contraseña',
        role_assignment: 'Rol y Asignación',
        staff_id: 'Staff ID',
        pin_configured: 'PIN Configurado',
        pin_not_configured: 'PIN No Configurado',
        new_pin: 'Nuevo PIN de 4 dígitos',
        assigned_hotel: 'Hotel Asignado',
        assigned_group: 'Grupo Asignado',
        staff_id_prefix: 'Staff ID:',
    },
    roles: {
        SuperAdmin: 'Super Administrador',
        superadmin: 'Super Admin',
        GroupAdmin: 'Administrador de Grupo',
        groupadmin: 'Admin Grupo',
        HotelAdmin: 'Administrador de Hotel',
        hoteladmin: 'Admin Hotel',
        Receptionist: 'Recepcionista',
        receptionist: 'Recepcionista',
        User: 'Usuario',
        user: 'Usuario',
        super_admin: 'Super Administrador',
        group_admin: 'Administrador de Grupo',
        hotel_admin: 'Administrador de Hotel',
        // Roles para choices de SelectInput
        'Super Admin': 'Super Admin',
        'Group Admin': 'Group Admin',
        'Hotel Admin': 'Hotel Admin',
    },
    labels: {
        hotel: 'Hotel',
        group: 'Grupo',
        no_hotel: 'Sin hotel asignado',
        no_group: 'Sin grupo asignado',
    },
    filters: {
        search: 'Buscar por nombre o email...',
        search_placeholder: 'Buscar usuarios...',
        role: 'Rol',
        all_roles: 'Todos los roles',
        active: 'Solo activos',
        inactive: 'Solo inactivos',
        hotel: 'Hotel',
        all_hotels: 'Todos los hoteles',
        group: 'Grupo',
        all_groups: 'Todos los grupos',
    },
    actions: {
        create: 'Crear Usuario',
        edit: 'Editar',
        delete: 'Eliminar',
        activate: 'Activar',
        deactivate: 'Desactivar',
        change_password: 'Cambiar contraseña',
        reset_password: 'Restablecer contraseña',
        assign_hotel: 'Asignar hotel',
        assign_group: 'Asignar grupo',
        view_activity: 'Ver actividad',
        send_invitation: 'Enviar invitación',
        more: 'Más acciones',
        reset_pin: 'Resetear PIN',
        save_pin: 'Guardar PIN',
        cancel: 'Cancelar',
    },
    messages: {
        no_users: 'No se encontraron usuarios',
        loading: 'Cargando usuarios...',
        create_success: 'Usuario creado con éxito',
        create_success_alt: 'Usuario creado con éxito',
        update_success: 'Usuario actualizado correctamente',
        delete_success: 'Usuario eliminado correctamente',
        delete_confirm: '¿Está seguro de que desea eliminar este usuario?',
        activate_success: 'Usuario activado correctamente',
        deactivate_success: 'Usuario desactivado correctamente',
        password_changed: 'Contraseña cambiada correctamente',
        password_reset: 'Se ha enviado un email para restablecer la contraseña',
        invitation_sent: 'Invitación enviada correctamente',
        email_exists: 'Ya existe un usuario con este email',
        invalid_role: 'Rol no válido para este usuario',
        cannot_delete_self: 'No puede eliminar su propio usuario',
        cannot_deactivate_self: 'No puede desactivar su propio usuario',
        access_denied: 'Acceso Denegado',
        pin_reset_success: 'PIN reiniciado con éxito',
        pin_reset_error: 'Error al reiniciar PIN',
        pin_length_error: 'El PIN debe tener 4 dígitos',
        login_format: 'Formato de login:',
    },
    validation: {
        name_required: 'El nombre es obligatorio y debe tener al menos 2 caracteres',
        name_min_length: 'El nombre debe tener al menos 2 caracteres',
        email_required: 'El email es obligatorio',
        email_format: 'Introduce un email válido',
        password_required: 'La contraseña es obligatoria y debe tener al menos 8 caracteres',
        password_min_length: 'La contraseña debe tener al menos 8 caracteres',
        password_mismatch: 'Las contraseñas no coinciden',
        role_required: 'El rol es obligatorio',
        hotel_required: 'Se debe asignar un hotel para este rol.',
        group_required: 'Se debe asignar un grupo para este rol.',
    },
    dialogs: {
        delete_title: 'Eliminar Usuario',
        delete_message: '¿Estás seguro de que quieres eliminar al usuario "{{name}}"?',
        delete_message_generic: '¿Estás seguro de que quieres eliminar este usuario?',
        delete_warning: 'Esta acción no se puede deshacer.',
        deactivate_title: 'Desactivar Usuario',
        deactivate_message: '¿Está seguro de que desea desactivar al usuario %{name}?',
        activate_title: 'Activar Usuario',
        activate_message: '¿Está seguro de que desea activar al usuario %{name}?',
        password_title: 'Cambiar Contraseña',
        password_message: 'Ingrese la nueva contraseña para el usuario',
        reset_pin_title: 'Resetear PIN para {{name}}',
    },
    password_requirements: {
        minLength: 'Al menos 8 caracteres',
        hasUpper: 'Una letra mayúscula',
        hasLower: 'Una letra minúscula',
        hasNumber: 'Un número',
    },
    errors: {
        passwords_do_not_match: 'Las contraseñas no coinciden',
        password_requirements_not_met: 'La contraseña no cumple los requisitos de seguridad',
        password_change_failed: 'Error al cambiar la contraseña',
    },
    notifications: {
        pin_invalid_format: 'El PIN debe tener 4 dígitos',
        pin_reset_success: 'PIN reiniciado con éxito',
        password_updated: 'Contraseña actualizada correctamente',
    },
    help: {
        role_description: 'El rol determina los permisos y accesos del usuario',
        hotel_assignment: 'Asignar el usuario a un hotel específico',
        group_assignment: 'Asignar el usuario a un grupo de hoteles',
        password_requirements: 'La contraseña debe tener al menos 8 caracteres, incluir mayúsculas, minúsculas, números y caracteres especiales',
        basic_user_data: 'Complete los datos básicos del usuario',
        basic_new_user_data: 'Complete los datos básicos del nuevo usuario',
        role_selection: 'Seleccione el rol',
        role_selection_detailed: 'Seleccione el rol',
        email_role_not_editable: 'Datos básicos. El email y el rol no son editables.',
        user_hotel_group: 'Hotel o grupo al que pertenece el usuario.',
        pin_setup: 'Establecer código PIN.',
    },
};

export default users;